import React from "react";

export default function RollBackIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.94531 15.2552H12.612C14.912 15.2552 16.7786 13.3885 16.7786 11.0885C16.7786 8.78854 14.912 6.92188 12.612 6.92188H3.44531"
        stroke="#666666"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3599 9.00885L3.22656 6.87552L5.3599 4.74219"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
